import config from 'src/config'

export const getBillDocumentUrl = ({ billId, fileName }) =>
  `${config.api.portal}/api/v1/bills/${billId}/documents/${fileName}`



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/Billing.utils.js